// extracted by mini-css-extract-plugin
export default {"PopupWindow":"WindowContainer_PopupWindow__M-4yF","DragHeader":"WindowContainer_DragHeader__6uAMq","DraggingHeader":"WindowContainer_DraggingHeader__4Mmn3"};